@switch (layout()) {
  @case ('sidebar_auxiliary') {
    <aura-sidebar-navigation-auxiliary-actions
      [user]="user()"
      [navigationItems]="navigationItems()"
      [appName]="appName()"
      [logoUrl]="logoUrl()"
      [homeUrl]="homeUrl()"
      [appBadge]="appBadge()"
    />
  }
  @case ('stacked') {
    <aura-stacked-layout-simple
      [user]="user()"
      [navigationItems]="navigationItems()"
      [appName]="appName()"
      [logoUrl]="logoUrl()"
      [homeUrl]="homeUrl()"
      [appBadge]="appBadge()"
      [audienceOptions]="audienceOptions()"
    />
  }
  @case ('brand_banner') {
    <aura-brand-banner [appName]="appName()" [logoUrl]="logoUrl()" />
  }
}
